import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useTrackViewedDiscussion } from "@air/analytics";
import { memo } from "react";
import { useSelector } from "react-redux";
import { useMount } from "__barrel_optimize__?names=useMount!=!react-use";
import { InitialCommentInputContainer } from "~/components/Discussions/InitialCommentInput/InitialCommentInputContainer";
import { PublicDiscussionsForm } from "~/components/PublicAssetModal/components/PublicDiscussionsForm";
import { PublicDiscussionsList } from "~/components/PublicAssetModal/components/PublicDiscussionsList";
import { usePublicPermissions } from "~/components/PublicPermissionsProvider";
import { useURLBoardIdSelector } from "~/hooks/useURLBoardIdSelector";
import { centralizedClipIdSelector } from "~/store/centralizedClip/selectors";
import { canEditAssetDiscussions } from "~/utils/permissions/assetPermissions";
export const PublicComments = /*#__PURE__*/ memo(()=>{
    const { permissions } = usePublicPermissions();
    const { trackViewedDiscussion } = useTrackViewedDiscussion();
    const boardId = useURLBoardIdSelector();
    const clipId = useSelector(centralizedClipIdSelector);
    const canEditDiscussions = canEditAssetDiscussions(permissions);
    useMount(()=>{
        if (clipId) {
            trackViewedDiscussion({
                boardId,
                clipId,
                location: "asset-page"
            });
        }
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(PublicDiscussionsList, {}),
            canEditDiscussions && /*#__PURE__*/ _jsx(InitialCommentInputContainer, {
                children: /*#__PURE__*/ _jsx(PublicDiscussionsForm, {})
            })
        ]
    });
});
PublicComments.displayName = "PublicComments";
